export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/buyCarIconEnabled.c5da2fb9.svg","height":20,"width":31,"blurWidth":0,"blurHeight":0};